<template>
    <div 
        class="modal fade"
        id="addPraticaModal"
        tabindex="-1"
        aria-labelledby="addContact"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addContact">
                        Aggiungi Pratica
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="submit">
                <div class="modal-body">
                    <div class="col-md-12 text-start">
                        <label for="nome" class="form-label">Nome:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form.nome" autofocus aria-describedby="nomeFeedback" required>
                            <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                                {{errors.nome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="data_inizio" class="form-label">Data Inizio:</label>
                        <div class="input-group has-validation">
                            <input type="date" :class="{'form-control':true, 'is-invalid':errors.data_inizio ? true : false}" id="data_inizio" v-model="form.data_inizio" autofocus aria-describedby="data_inizioFeedback" required>
                            <div v-if="errors.data_inizio" id="data_inizioFeedback" class="invalid-feedback">
                                {{errors.data_inizio}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <input class="form-check-input" type="checkbox" value="1" v-model="form.lunedi" id="flexCheckChecked" checked>
                        <label class="form-check-label" for="flexCheckChecked">
                            Lunedì
                        </label>
                    </div>
                    <div class="col-md-12 text-start">
                        <input class="form-check-input" type="checkbox" value="1" v-model="form.martedi" id="flexCheckChecked" >
                        <label class="form-check-label" for="flexCheck">
                            Martedì
                        </label>
                    </div>
                    <div class="col-md-12 text-start">
                        <input class="form-check-input" type="checkbox" value="1" v-model="form.mercoledi" id="flexCheck" >
                        <label class="form-check-label" for="flexCheck">
                            Mercoledì
                        </label>
                    </div>
                    <div class="col-md-12 text-start">
                        <input class="form-check-input" type="checkbox" value="1" v-model="form.giovedi" id="flexCheck" >
                        <label class="form-check-label" for="flexCheck">
                            Giovedì
                        </label>
                    </div>
                    <div class="col-md-12 text-start">
                        <input class="form-check-input" type="checkbox" value="1" v-model="form.venerdi" id="flexCheck" >
                        <label class="form-check-label" for="flexCheck">
                            Venerdì
                        </label>
                    </div>
                    <div class="col-md-12 text-start">
                        <input class="form-check-input" type="checkbox" value="1" v-model="form.sabato" id="flexCheck" >
                        <label class="form-check-label" for="flexCheck">
                            Sabato
                        </label>
                    </div>
                    <div class="col-md-12 text-start">
                        <input class="form-check-input" type="checkbox" value="1" v-model="form.domenica" id="flexCheck" >
                        <label class="form-check-label" for="flexCheck">
                            Domenica
                        </label>
                    </div>

                    
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Annulla
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        Salva
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        paziente: Object,
        isEdit: Boolean
    },
    data() {
        return {
            modal: null,
            form: this.$inertia.form({
                nome: "" ,
                data_inizio: "" ,
                paziente_id: this.paziente.id,
                lunedi: false,
                martedi: false,
                mercoledi: false,
                giovedi: false,
                venerdi: false,
                sabato: false,
                domenica: false
            }),
            errors: {
               nome: null,
               data_inizio: null
            },
        };
    },
    mounted() {
        var modalEl = document.getElementById('addPraticaModal')
        this.modal = new Modal(modalEl)
        this.modal.show();
        
        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelStatusChanged',false)
        })
    },
    methods: {
        close(){
            //this.isOpen = false
        },
        submit() {
            let route = this.route("pazienti.aggiungi_pratica")
            let method = 'post'
            this.form['post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("cognome")) {
                            toast.message = errors.cognome;
                            this.errors.cognome = errors.cognome;
                        }

                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                        if (errors.hasOwnProperty("cellulare")) {
                            toast.message = errors.cellulare;
                            this.errors.cellulare = errors.cellulare;
                        }

                        if (errors.hasOwnProperty("email")) {
                            toast.message = errors.email;
                            this.errors.email = errors.email;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },
    },
};
</script>
